import sIcon2 from "../images/icons/icon_dart_board_2.svg";
import sIcon3 from "../images/icons/icon_target.svg";

const Policy = [
  {
    title: "Our Mission",
    subTitle:
      " We are deeply committed to building a cleaner, greener, and more inclusive future through intelligent AI-driven innovations, while nurturing the next generation of highly skilled tech leaders. Our goal is to help today’s businesses adopt smart, sustainable IT solutions that improve efficiency and cut carbon emissions. We focus on bringing modern digital tools and intelligent technologies to key sectors like education, healthcare, finance, and clean energy. This approach supports steady growth, responsible innovation, and lasting well-being for people and communities.",
    icon: sIcon2,
    icon1: "fas fa-leaf card_i"
  },
  {
    title: "Our Vision",
    subTitle:"By 2030, we plan to train over 1,000 professionals in high-demand fields. These include Artificial Intelligence, Cybersecurity, Data Science, and smart city technologies powered by IoT. Our mission is to promote eco-friendly IT solutions across industries, helping organizations adopt sustainable and efficient digital practices. We aim to create a smart, sustainable, and digitally empowered environment. Through advanced training programs, we are creating a digital workforce that’s equipped to lead innovation and support long-term progress. We are committed to driving positive change, fostering growth, and shaping a future that balances technology with sustainability.",
    icon: sIcon3,
    icon1: "fas fa-lightbulb card_i"
  },
];

export default Policy;
